import React from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Badge from 'react-bootstrap/Badge';
import VideoYoutube from './VideoYoutube';
import { useNavigate } from 'react-router-dom'

const ProyectosHomeCard = ({ id_proyecto, titulo_proyecto, descripcion_proyecto, tipo_proyecto, nombre_grupo, setShowID, setShow, disabledButtonVotar, votarPropuesta, video_youtube }) => {

    const cambiarUrl = (id_proyecto) => {
        setShow(true)
        setShowID(id_proyecto)
        window.history.pushState({}, null, `/pp/propuestas/${id_proyecto}`);
    }
    const navigate = useNavigate();
    const navegarToVotar = (destino) => {
        // SINO inició sesion va a esa pagina
        const destinourl = '/votarpropuestas/';
        navigate(destinourl);
      }    

    return (

        <Row className='card-proyectos' style={{
            border: '1px solid #ccc',
            marginBottom: '30px',
            paddingTop: '30px',
            paddingBottom: '30px',
            borderRadius: '10px',
            marginLeft: '10px',
            marginRight: '10px'
        }}>
            <Col md={8}>
                <Card.Body>
                    <div style={{ marginBottom: '10px' }} >
                        <Badge bg="success" style={{ marginLeft: 'auto', marginRight: '0' }}>
                            Propuesta Factible
                        </Badge>
                    </div>
                    <Card.Title style={{ marginBottom: '10px' }}>
                        <span style={{ fontSize: '30px' }}>
                            Propuesta #{id_proyecto} - {titulo_proyecto}
                        </span>
                    </Card.Title>
                    <p>
                        {descripcion_proyecto}
                    </p>
                    <ListGroup style={{ fontSize: '16px' }}>
                        <ListGroup.Item>
                            <i className="bi bi-hash icon-grey"></i>
                            Propuesta Número: <strong>{id_proyecto}</strong>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <i className="bi bi-lightbulb icon-grey"></i>
                            Tipo de proyecto: <strong>{tipo_proyecto}</strong>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <i className="bi bi-people-fill icon-grey"></i>
                            Nombre del grupo: <strong>{nombre_grupo}</strong>
                        </ListGroup.Item>
                    </ListGroup>
                    <div style={{ textAlign: 'right', marginTop: '20px' }}>
                        <button
                            type="button"
                            onClick={() => cambiarUrl(id_proyecto)}
                            className="btn btn-success btn-lg px-4"
                            style={{ borderWidth: '2px', marginRight: '12px' }}>
                            Ver detalle de la propuesta <i className="bi bi-eye"></i>
                        </button>
                        <button
                            type="button"
                            onClick={() => votarPropuesta(id_proyecto)}
                            disabled={disabledButtonVotar}
                            className="btn btn-light btn-lg px-4 me-md-2 fw-bold"
                            style={{
                                color: disabledButtonVotar ? '#6c757d' : '#E91E63',
                                marginBottom:'20px',
                                cursor: disabledButtonVotar ? 'not-allowed' : 'pointer'
                            }}
                        >
                            {disabledButtonVotar ? (
                                <>
                                    Tenés que iniciar sesión para votar <i className="bi bi-lock"></i>
                                </>
                            ) : (
                                <>
                                    Votar esta propuesta <i className="bi bi-envelope-paper"></i>
                                </>
                            )}

                        </button>
                        {disabledButtonVotar &&
                            <button type="button" onClick={navegarToVotar} className="btn btn-light btn-lg px-4 me-md-2 fw-bold" style={{ color: '#E91E63' }}>Iniciar sesión para votar</button>
                        }
                    </div>
                </Card.Body>
            </Col>
            <Col md={4} className="d-flex align-items-center justify-content-center mt-4">
                <div className="w-100" style={{
                    minWidth: '280px',  // Tamaño mínimo en móvil
                    maxWidth: {
                        xs: '100%',     // En móvil, ancho completo de la columna
                        md: '320px',    // En tablets
                        lg: '400px'     // En escritorio
                    }[window.innerWidth >= 1200 ? 'lg' : window.innerWidth >= 768 ? 'md' : 'xs']
                }}>
                    <VideoYoutube url={video_youtube} />
                </div>
            </Col>
        </Row>



    )
}

export default ProyectosHomeCard